export const eventChooserFormNames = {
    INSERTION: "insertion",
    INSEMINATION: "insemination",
    USG: "usg",
    NO_PREGNANCY: "noPregnancy",
    PARTURITION: "parturition",
    SEPARATION_TO_PORKHOUSE: "separationToPigletHouse",
    SEPARATION_TO_BABY_ROOM: "separationToBabyRoom",
    SEPARATION_FROM_BABY_ROOM: "separationFromBabyRoom",
    SEPARATION_TO_MOMMY: "separationToMommy",
    SEPARATION_TO_MOMMY_GILTS: "separationToMommyGilts",
    TREATMENT: "treatment",
    TREATMENT_LOCATION: "treatmentLocation",
    GRAFTING: "grafting",
    GRAFTING_LOCATION: "graftingLocation",
    FALL_PIGLETS: "pigletsFall",
    TRANSFER: "transfer",
    TRANSFER_CHAMBER: "transferChamber",
    TRANSFER_STAND: "transferStand",
    FALL: "fall",
    FALL_LOCATION: "fallLocation",
    FALL_BABY_ROOM: "fallBabyRoom",
    FALL_BABY_ROOM_LOCATION: "fallBabyRoomLocation",
    SELL: "sell",
    SELL_LOCATION: "sellLocation",
    SELECTION: "selection",
    WEIGHTING: "weighting",
    WEIGHTING_LOCATION: "weightingLocation",
    ACTIVE_NIPPLES: "activeNipples",
    RECLASSIFY: "reclassify",
    RECLASSIFY_LOCATION: "reclassifyLocation",
    RECLASSIFY_LOCATION_NUMBERS: "reclassifyLocationNumbers",
    RECLASSIFY_SOW: "reclassifySow",
    PIGLETS_TREATMENT: "pigletsTreatment",
    HEAT: "heat",
    LOST_EARRING: "lostEarring",
    DOSATRON: "dosatron",
    PARTURITION_STATE: "parturitionState",
    CASTRATION: "castration",
    TATTOO: "tattoo",
    COMMENTS: "comments",
    TAGGING: "tagging",
    TAGGING_LOCATION: "taggingLocation",
    FALL_TATTOOED_PIGLETS: "fallTattooedPiglets",
    GILTS_SEPARATION: "giltsSeparation",
    IS_MOMMY: "isMommy",
    FAT_MEASUREMENT: "fatMeasurement",
};
